import { FETCH_APP_NAVIGATION_SUCCEEDED } from '../constants/NavigationConstants';

export default function NavigationReducer(state = [], action) {
  switch (action.type) {
    case FETCH_APP_NAVIGATION_SUCCEEDED: {
      const { navigation } = action;
      return [...navigation];
    }

    default:
      return state;
  }
}
